import type { FC } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import "antd/dist/reset.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import Store from "./redux/Store";
import Navigator from "./navigator/Navigator";
import { initAxios } from "./utils/utility";
import axiosInstance from "./redux/axios";
import { AuthProvider } from "./context/auth-context";

const App: FC = () => {
  initAxios(axiosInstance, null);

  return (
    <Provider store={Store}>
      <BrowserRouter>
        <AuthProvider>
          <Navigator />
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
